import { render, staticRenderFns } from "./fodder.vue?vue&type=template&id=5459c2bd&scoped=true&"
import script from "./fodder.vue?vue&type=script&lang=js&"
export * from "./fodder.vue?vue&type=script&lang=js&"
import style0 from "./fodder.vue?vue&type=style&index=0&id=5459c2bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5459c2bd",
  null
  
)

export default component.exports